import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { Flex } from "antd";
import Fixture from "./fixture/FixtureMobile";
const Fixtures = ({
  fixtures,
  showStartDate,
  fixtureClickCallback,
  onFavoriteToggle
}) => {
  return /* @__PURE__ */ jsx(Flex, { vertical: true, gap: 8, children: fixtures.map((fixture, idx) => /* @__PURE__ */ jsx(
    Fixture,
    {
      fixture,
      showStartDate,
      fixtureClickCallback,
      onFavoriteToggle
    },
    `${fixture.id}_${idx}`
  )) });
};
var stdin_default = memo(Fixtures);
export {
  stdin_default as default
};
